import{createPluginCenter as e,request as t,markdown as n}from"@topwrite/core";export{BaseConfig,Book,Config,File,LetterAvatar,Level,Summary,SummaryArticle,SummaryPart,aes,isEncryptedData,isRequestError,isUrl,markdown,md5,pluginCenter,request}from"@topwrite/core";import o from"url";import{jsx as r,Fragment as i,jsxs as s}from"react/jsx-runtime";import c,{Suspense as a,Fragment as l,Component as d,useMemo as u,createElement as m,useState as h,useEffect as p,useCallback as f,createContext as g,useContext as w,useRef as v,Children as b}from"react";import y from"@babel/runtime/helpers/defineProperty";import{useSelector as x,Model as k,createStore as C,Provider as $,useActions as E}from"@topthink/redux-model";export{Model}from"@topthink/redux-model";import S from"loadjs";export{default as loadjs}from"loadjs";import D from"query-string";import{noop as P,debounce as T,throttle as M}from"lodash";import z,{createGlobalStyle as j}from"styled-components";export{ThemeProvider,createGlobalStyle,css,keyframes,default as styled}from"styled-components";import{createIntlCache as L,createIntl as I,RawIntlProvider as A}from"react-intl";export{IntlContext,defineMessage,defineMessages,useIntl}from"react-intl";import{toc as O}from"mdast-util-toc";import _ from"remark-slug";import{all as N,toHast as W}from"mdast-util-to-hast";import{convert as U}from"unist-util-is";import H from"html-tags";import{encode as q}from"mdurl";import{toString as V}from"mdast-util-to-string";export{default as useEvent}from"@react-hook/event";export{useHotkeys}from"react-hotkeys-hook";export{useAsync,useAsyncCallback,useAsyncFetchMore}from"react-async-hook";export{Helmet}from"react-helmet";window.TopWritePlugins={};class B extends HTMLElement{connectedCallback(){this.addEventListener("click",(e=>{if(e.preventDefault(),!this.isContentEditable){const e=this.attributes.getNamedItem("src");let t=e?.value;if(t){let e=document.createElement("a");e.download=this.textContent||"",e.style.display="none",e.target="_blank",e.href=o.resolve(location.href,t),document.body.appendChild(e),e.click(),document.body.removeChild(e)}}}))}}function F(e){let{component:t,defaultComponent:n=l,props:o,children:i=null,context:s}=e;return null===t?null:r(a,{fallback:null,children:r(t,{props:o,Component:n,context:s,children:i})})}customElements.define("t-attachment",B);class G extends d{constructor(){super(...arguments),y(this,"state",{hasError:!1})}componentDidCatch(){this.setState({hasError:!0})}render(){return this.state.hasError?null:this.props.children}}var R=(e,t)=>e.filter((e=>{let{descriptor:n}=e;return t===n.role})).sort(((e,t)=>{let{descriptor:{priority:n=0}}=e,{descriptor:{priority:o=0}}=t;return n-o})).map((e=>{return t=e.Component,e=>r(G,{children:r(t,{...e},"WrappedComponent")});var t}));function J(e){let{component:t,props:n}=e;return m(t,n)}function K(e){let{props:t,role:n,component:o,context:i}=e;const s=o?r(J,{component:o,props:t,context:i}):null,c=x("components");return u((()=>R(c,n)),[c,n]).reduce(((e,n)=>r(F,{defaultComponent:o,component:n,props:t,context:i,children:e})),s)}function Q(e){let{props:t,component:n,role:o,context:s}=e;const c=x("components"),a=u((()=>R(c,o)),[c,o]);return r(i,{children:a.map(((e,o)=>r(F,{defaultComponent:n,component:e,props:t,context:s},o)))})}async function X(e){let t=`topwrite-plugin-${e.name}`;if(!S.isDefined(t)){let n=`${e.host}/${e.main}`;try{await S(n,t,{returnPromise:!0})}catch{console.warn(`插件${e.name}加载失败`)}}}function Y(e,t){let n;return n=t instanceof Array?{Component:t[0],descriptor:{role:e,...t[1]}}:{Component:t,descriptor:{role:e}},n}const Z="localStorage";function ee(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:Z;if("undefined"==typeof window)throw new Error("Browser storage is not available on NodeJS / TopWrite SSR process");if("none"===e)return null;try{return window[e]}catch(e){return null}}const te={get:()=>null,set:()=>{},del:()=>{}},ne=(e,t)=>{const n=ee(t?.persistence);return null===n?te:{get:()=>n.getItem(e),set:t=>n.setItem(e,t),del:()=>n.removeItem(e)}};function oe(){const e=ee(arguments.length>0&&void 0!==arguments[0]?arguments[0]:Z);if(!e)return[];const t=[];for(let n=0;n<e.length;n+=1){const o=e.key(n);null!==o&&t.push(o)}return t}function re(){const e=x("book");if(!e)throw new Error("book object not initialized");return e}function ie(){const{config:e}=re();return e.getValue("themeConfig")}const se="light",ce="dark";function ae(e){document.documentElement.setAttribute("data-theme",e)}const le=e=>{const t=re(),n=u((()=>ne(`${e}.${t.id}.theme`)),[t.id,e]),{defaultMode:o}=ie(),[r,i]=h((()=>{const e=(e=>e===ce?ce:se)(n.get()||o);return ae(e),e}));p((()=>{ae(r)}),[r]);const s=f((()=>{i(se),n.set(se)}),[n]),c=f((()=>{i(ce),n.set(ce)}),[n]);return{isDarkTheme:r===ce,setLightTheme:s,setDarkTheme:c}},de=g(void 0);function ue(e){let{children:t,context:n}=e;const{isDarkTheme:o,setLightTheme:i,setDarkTheme:s}=le(n);return r(de.Provider,{value:{isDarkTheme:o,setLightTheme:i,setDarkTheme:s},children:t})}function me(){const e=w(de);return null==e?{isDarkTheme:!1,setLightTheme:P,setDarkTheme:P}:e}const he=j`

  //TODO 转移到异步加载
  //附件
  t-attachment {
    color: var(--ttw-primary-color, #3c60ff);
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    overflow: hidden;
    padding: 0 4px;
    vertical-align: bottom;
    margin: 0 1px;

    &:before {
      content: '';
      width: 18px;
      height: 18px;
      background-color: var(--ttw-primary-color, #3c60ff);
      mask: url("${"data:image/svg+xml,%3csvg t='1642406480574' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='2254' width='16' height='16'%3e %3cpath d='M874.666667 467.2c-10.666667-10.666667-29.866667-12.8-42.666667 0l-343.466667 341.333333c-74.666667 74.666667-198.4 74.666667-275.2 0-36.266667-36.266667-57.6-85.333333-57.6-136.533333s19.2-100.266667 57.6-136.533333L556.8 192c46.933333-46.933333 121.6-46.933333 168.533333 0 23.466667 23.466667 34.133333 53.333333 34.133334 83.2 0 32-12.8 61.866667-34.133334 83.2L384 704c-17.066667 17.066667-44.8 17.066667-64 0-8.533333-8.533333-12.8-19.2-12.8-32s4.266667-23.466667 12.8-32l317.866667-315.733333c10.666667-10.666667 12.8-29.866667 0-42.666667-10.666667-12.8-29.866667-12.8-42.666667 0L277.333333 597.333333c-19.2 19.2-29.866667 46.933333-29.866666 74.666667S258.133333 725.333333 277.333333 746.666667c40.533333 40.533333 106.666667 40.533333 147.2 0L768 403.2c34.133333-34.133333 53.333333-78.933333 53.333333-125.866667s-19.2-93.866667-53.333333-125.866666a178.986667 178.986667 0 0 0-253.866667 0l-341.333333 341.333333c-46.933333 46.933333-74.666667 110.933333-74.666667 179.2s25.6 132.266667 74.666667 179.2c49.066667 49.066667 115.2 74.666667 179.2 74.666667s130.133333-25.6 179.2-74.666667l343.466667-341.333333c10.666667-12.8 10.666667-32 0-42.666667z' p-id='2255'%3e%3c/path%3e%3c/svg%3e"}") no-repeat center;
      margin-right: 4px;
    }

    &:after {
      content: "(" attr(size) ")";
      margin-left: 4px;
      display: none;
    }

    &[size]:after {
      display: inline;
    }

    &:hover {
      background: rgba(0, 0, 0, .1);
    }

    &:read-write {
      cursor: text;
    }
  }
`;const pe=new class extends k{constructor(){super(...arguments),y(this,"initialState",[])}*register(e){yield this.setState((t=>t.push(e)))}};const fe=new class extends k{};var ge=Object.freeze({__proto__:null,components:pe,options:fe});function we(e,t,n){const o="function"==typeof t;o||(n=t),p((()=>{let n;const r=e();return Promise.resolve(r).then((e=>{n=e})),()=>{o&&t(n)}}),n)}function ve(e){return e.__esModule&&e.default?e.default:e}const be=g(void 0),ye=()=>{const e=w(be);if(void 0===e)throw new Error("useIntlContext must be used within a Layout component");return e},xe=e=>{let{localize:t,children:n}=e;const{addMessages:o}=ye(),[s,c]=h(!0);return we((async()=>{c(!0),await o(t),c(!1)}),[t]),s?null:r(i,{children:n})},ke=e=>{let{children:t}=e;const{locale:n,messages:o}=ye(),i=u((()=>{const e=L();return I({locale:n,messages:o,defaultLocale:"en"},e)}),[n,o]);return r(A,{value:i,children:t})},Ce=e=>{let{children:t,locale:n,messages:o}=e;const[i,s]=h(o);return r(be.Provider,{value:{locale:n,messages:i,addMessages:async e=>{s(Object.assign({},i,ve(await e(n))))}},children:r(ke,{children:t})})};class $e{constructor(e,t,n){y(this,"name",void 0),y(this,"book",void 0),y(this,"models",{...ge}),y(this,"components",[]),y(this,"activates",[]),y(this,"plugins",[]),y(this,"initialState",void 0),this.name=e,this.book=t,this.initialState=n}registerComponents(e,t){for(let[n,o]of Object.entries(e))o&&("plugin:setting"===n&&(n=`plugin:setting:${t}`),this.components.push(Y(n,o)))}registerModels(e,t){for(const[n,o]of Object.entries(e))t?this.models[`@${t}@${n}`]=o:this.models[n]=o}async registerPlugins(e){this.plugins=e;for(const t of e)try{this.registerComponents(t.components,t.name),this.registerModels(t.models,t.name),t.activate&&this.activates.push(t.activate),t.register&&await t.register(this.name,this.book)}catch(e){console.log(e)}}async createApp(e){const t=navigator.language,n=await this.loadMessages(t,e),o=C(this.models,{book:this.book,components:this.components,...this.initialState}),c=e=>{let{children:t}=e;return r(i,{children:t})},a=e=>{let{children:t}=e;const n=r(K,{role:`activate:${this.name}`,props:{children:t,name:this.name},component:c});return this.activates.reduce(((e,t)=>{const n=t(this.name);return void 0!==n?r(i,{children:n}):e}),n)};return e=>{let{children:i}=e;return r($,{store:o,children:s(ue,{context:this.name,children:[r(he,{}),r(Ce,{locale:t,messages:n,children:r(a,{children:i})})]})})}}async loadMessages(e,t){return await this.plugins.reduce((async(t,n)=>{const o=ve(await t);return n.localize?Object.assign({},o,ve(await n.localize(e))):o}),t(e))}}async function Ee(n,o,r,i,s,c){const a=await async function(n,o){let r=[];if(o){const t=e(o);try{r=await t.getInstalled(n),r=r.filter((e=>!window.TopWritePlugins[e.name]?.meta))}catch{}}try{const e=sessionStorage.getItem("PLUGIN_DEV"),n=D.parse(window.location.search);if("dev"in n||e){const o=n.dev||e||8080;try{const e=(await t.get(`http://localhost:${o}/meta`)).data;r=r.filter((t=>t.name!==e.name&&!("theme"===e.type&&"theme"===t.type))),window.TopWritePlugins[e.name]&&delete window.TopWritePlugins[e.name],r.unshift(e),sessionStorage.setItem("PLUGIN_DEV",String(o))}catch(e){console.warn(e),sessionStorage.removeItem("PLUGIN_DEV")}}}catch{}const i=Object.entries(window.TopWritePlugins).filter((e=>{let[,t]=e;return!!t.meta})).map((e=>{let[,t]=e;return t.meta})),s=i.some((e=>"theme"===e.type)),c=Object.keys(window.TopWritePlugins),a=[];for(let e of r)e.disabled||c.includes(e.name)||s&&"theme"===e.type||a.push(X(e));return await Promise.all(a),i.push(...r),window.TopWritePluginsMeta=i,Object.values(window.TopWritePlugins||{})}(o,c),l=new $e(n,o,i);return l.registerModels(r),await l.registerPlugins(a),await l.createApp(s)}function Se(e){return E(e)}function De(e){return x(e)}function Pe(e){return[De(e),Se(e)]}function Te(e){const t=v(null),[n,o]=h(e);p((()=>{t.current&&(t.current(),t.current=null)}),[n]);return[n,(e,n)=>{t.current="function"==typeof n?n:null,o(e)}]}function Me(){const e=document.currentScript;if(!e)throw new Error("Automatic publicPath is not supported in this browser");return e.src.replace(/#.*$/,"").replace(/\?.*$/,"").replace(/\/[^\/]+$/,"/")}class ze{constructor(e){let{name:t,meta:n,models:o={},components:r={},activate:i,register:s,localize:c,config:a}=e;y(this,"name",void 0),y(this,"config",void 0),y(this,"localize",void 0),y(this,"models",void 0),y(this,"components",void 0),y(this,"activate",void 0),y(this,"register",void 0),y(this,"meta",void 0),this.name=t,this.meta=n,this.models=o,this.components=r,this.activate=i,this.register=s,this.localize=c,this.config=a}}const je=U("root"),Le=U("element"),Ie=U("text");function Ae(e){return e.filter((e=>!(Ie(e)&&"\n"===e.value)))}function Oe(e,t,n){const o=t.properties,r=t.tagName,i={...o};n.prefix&&(n.key++,i.key=n.prefix+n.key);const s=[],c=Ae(t.children),a=c?c.length:0;let l=-1;for(;++l<a;){const t=c[l];Le(t)?s.push(Oe(e,t,n)):Ie(t)&&s.push(t.value)}return e.call(t,r,i,s.length>0?s:void 0)}function _e(e,t){let{extensions:n=[],creator:o=c.createElement}=t;const r={allowDangerousHtml:!1,handlers:{...n.reduce(((e,t)=>Object.assign(e,t)),{}),textDirective:(e,t)=>e({},"textDirective",{name:t.name,attributes:t.attributes},N(e,t)),leafDirective:(e,t)=>e({},"leafDirective",{name:t.name,attributes:t.attributes},N(e,t)),containerDirective(e,t){"children"in t||(t.children=[]);let n=!1;for(const e of t.children)if(e.data?.directiveLabel){n=!0;break}return n||t.children.unshift({type:"paragraph",children:[{type:"text",value:""}]}),e({},"containerDirective",{name:t.name,attributes:t.attributes},N(e,t))},heading(e,t){const n=e(t,"heading",N(e,t));return n.properties={...n.properties,depth:t.depth},n}},unknownHandler:()=>null},i=W(e,r);if(je(i))return Ae(i.children).map(((e,t)=>Le(e)?Oe(o,e,{key:0,prefix:`h-${t}-`}):Ie(e)?e.value:void 0));if(!Le(i))throw new Error("Expected root or element, not `"+(i&&i.type||i)+"`");return Oe(o,i,{key:0,prefix:"h-"})}const Ne=e=>{let{value:t}=e;return r("pre",{children:r("code",{children:t})})},We=e=>{let{value:t}=e;return r("code",{children:t})};const Ue=g({}),He=Ue.Provider,qe=()=>w(Ue);function Ve(e,t){return qe()[e]||t}const Be=["video","audio"];function Fe(e){const{name:t,attributes:n,children:o}=e;let i=Ve(t),s=`html:${t}`;return customElements.get(`t-${t}`)?i=i||`t-${t}`:Be.includes(t)||(i=void 0,s=`directive:${t}`),r(K,{role:s,props:{...n,children:o},component:i})}function Ge(e){let{depth:t=5,...n}=e;return m(`h${t}`,n)}const Re={"x-inline":function(e){const{name:t,value:n}=e;return r(K,{role:`inline:${t}`,props:{type:"inline",name:t,value:n},component:We})},"x-block":function(e){const{name:t,value:n,parameter:o}=e;return r(K,{role:`block:${t}`,props:{type:"block",name:t,parameter:o,value:n},component:Ne})},textDirective:Fe,leafDirective:Fe,containerDirective:function(e){let{name:t,attributes:n,children:o}=e,i=Ve(t),s=`html:${t}`;const[c,...a]=b.toArray(o),l={children:a,label:c,...n};return customElements.get(`t-${t}`)?i=i||`t-${t}`:Be.includes(t)||(i=void 0,s=`directive:${t}`),r(K,{role:s,props:l,component:i})},heading:function(e){const t=Ve("heading",Ge);return r(K,{role:"html:heading",props:e,component:t})}},Je=e=>{let{tagName:t,inject:n=!0,...o}=e;const i=Ve(t,t);return n?Re[t]?m(Re[t],o):H.includes(t)?r(K,{role:`html:${t}`,props:o,component:i}):(console.warn(`unknown tagName: ${t}`),null):m(i,o)};function Ke(e){let{as:t=l,children:o,components:c={},aside:a=!0,header:d,footer:h,css:p,sectionAs:f,inject:g=!0,...w}=e;const v=u((()=>n().use(_).freeze()),[]),[b,y]=u((()=>{try{const e=v.data("toHastExtensions"),t=v.runSync(v.parse(o));let n=null;if(a){const o=O(t).map;o&&(n=_e(o,{extensions:[...e,{link:(e,t)=>{const n=V(t.children);return e(t,"a",{href:q(t.url)},[{type:"text",value:n}])}}]})),"object"==typeof a&&(n=s(i,{children:[a.header,n,a.footer]}))}const r=_e(t,{extensions:e,creator:(e,t,n)=>m(Je,{...t,tagName:e,inject:g},n)});return[r,n]}catch(e){return console.log(e),[null,null]}}),[o,a,v,g]);return m(t,w,s(He,{value:c,children:[s("article",{children:[d,r(Qe,{$css:p,as:f,children:b}),h]}),y&&r("aside",{children:y})]}))}const Qe=z.section`
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  line-height: 1.2;
  word-wrap: break-word;

  & > *:first-child {
    margin-top: 0 !important;
  }

  & > *:last-child {
    margin-bottom: 0 !important;
  }

  h1, h2, h3, h4, h5, h6, p, ul, ol, blockquote, pre, table, audio, video {
    margin-top: 0;
    margin-bottom: 1rem;
    line-height: 1.5;
    padding: 0;

    &:last-child {
      margin-bottom: 0 !important;
    }

    &:first-child {
      margin-top: 0 !important;
    }
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 500;
    margin-top: 2rem;
    margin-bottom: 1rem;
    line-height: 1.2;

    &.align-right {
      text-align: right;
    }

    &.align-center {
      text-align: center;
    }
  }

  h1 {
    font-size: 2.5em;
  }

  h2 {
    font-size: 2em;
  }

  h3 {
    font-size: 1.75em;
  }

  h4 {
    font-size: 1.5em;
  }

  h5 {
    font-size: 1.25em;
  }

  hr {
    border: 0;
    border-bottom: 1px solid #eeeeee;
    margin-bottom: 0.5em;
  }

  ul {
    padding-left: 2em;

    ul {
      margin: 0;
    }
  }

  ol {
    padding-left: 2em;
  }

  li {
    line-height: 2;

    &.task-list-item {
      list-style: none;
      position: relative;

      input[type=checkbox] {
        position: absolute;
        left: -1.5em;
        top: 0.5em;
        width: 1em;
        height: 1em;
      }
    }

    &.align-right {
      text-align: right;
    }

    &.align-center {
      text-align: center;
    }
  }

  code {
    display: inline-block;
    border-radius: 4px;
    padding: .2em .4em;
    background-color: #f7f7f7;
    word-break: break-all;
    font-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
    white-space: pre;
    line-height: 1.3;
    color: inherit;
    font-size: inherit;
    margin: -.2em .4em;
  }

  pre {
    padding: 1.05em;
    overflow: auto;
    line-height: 1.45;
    background-color: #f7f7f7;
    border: 0;
    border-radius: 3px;
    font-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
    font-size: inherit;
  }


  pre > code {
    display: inline;
    max-width: 100%;
    padding: 0;
    margin: 0;
    overflow: initial;
    line-height: inherit;
    background-color: rgba(0, 0, 0, 0);
    border: 0;
    tab-size: 4;
  }

  p {
    &.align-right {
      text-align: right;
    }

    &.align-center {
      text-align: center;
    }
  }

  table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
    line-height: 1.8;
    border-spacing: 0;

    th {
      text-align: left;

      &[align='center'] {
        text-align: center;
      }

      &[align='right'] {
        text-align: right;
      }
    }

    th, td {
      border: 1px solid #e0e0e0;
      padding: 3px 12px;
      height: 34px;
    }

    tr:hover td {
      background-color: #f1f1f1;
    }
  }

  img {
    max-width: 100%;
    display: inline-block;
    padding: 3px;
    vertical-align: middle;
  }

  a {
    text-decoration: none;
    color: var(--ttw-primary-color, #3c60ff);

    &:hover {
      text-decoration: underline;
    }
  }

  blockquote {
    padding: 5px 5px 5px 15px;
    color: #777777;
    border-left: 4px solid #dddddd;

    &.info {
      border-left-color: #5bc0de;
      color: #5bc0de;
      background-color: #f4f8fa;
    }

    &.warning {
      background-color: #fcf8f2;
      border-color: #f0ad4e;
      color: #f0ad4e;
    }

    &.danger {
      color: #d9534f;
      background-color: #fdf7f7;
      border-color: #d9534f;
    }

    &.success {
      background-color: #f3f8f3;
      border-color: #50af51;
      color: #50af51;
    }
  }

  video {
    display: block;
    width: 100%;
  }

  audio {
    display: block;
    width: 100%;
  }

  html[data-theme=dark] & {
    code {
      background-color: #333437;
    }

    pre {
      background-color: #333437;
    }

    h1, h2, hr {
      border-color: #404040;
    }

    th, td {
      border-color: #404040;
    }

    tr:hover td {
      background-color: #333437;
    }
  }

  ${e=>e.$css}
`;function Xe(e){let{onChange:t,onCompositionStart:n,onCompositionEnd:o,...i}=e;const s=v(!1),c=f((e=>{s.current||t?.(e)}),[t]),a=f((e=>{s.current=!0,n?.(e)}),[n]),l=f((e=>{s.current=!1,t?.(e),o?.(e)}),[o,t]);return r("input",{...i,onChange:c,onCompositionStart:a,onCompositionEnd:l})}function Ye(e){const t=v();return p((()=>{t.current=e}),[e]),t.current}function Ze(e){const t=v(e);p((()=>(document.title=e,()=>{document.title=t.current})),[e])}function et(e,t,n){const o=v(e),r=v(T(e,t,n));return p((()=>{o.current=e})),p((()=>{r.current=T((function(){o.current(...arguments)}),t,n)}),[t,n]),r.current}function tt(e,t,n){const o=v(e),r=v(M(e,t,n));return p((()=>{o.current=e})),p((()=>{r.current=M((function(){o.current(...arguments)}),t,n)}),[t,n]),r.current}function nt(){return x("options")}const ot=new EventTarget;function rt(){return ot}function it(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"";const[n,o]=h((()=>window.localStorage.getItem(e)||t)),r=f((t=>{o(t),window.localStorage.setItem(e,t)}),[o,e]);p((()=>{const r=window.localStorage.getItem(e);n!==r&&o(r||t)}));const i=f((r=>{r.key===e&&r.newValue!==n&&o(r.newValue||t)}),[n]);return p((()=>(window.addEventListener("storage",i),()=>window.removeEventListener("storage",i))),[i]),[n,r]}function st(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:window.document;if("string"==typeof e){e=(new DOMParser).parseFromString(e,"text/html")}const t=e.querySelector('script[type="application/payload+json"]');if(t)try{return JSON.parse(t.innerHTML)}catch{return{}}}var ct=Object.freeze({__proto__:null,encode:function(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(null===e)return"";try{return window.btoa(unescape(encodeURIComponent(e)))}catch(e){if(t)throw e;return""}},decode:function(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(null===e)return"";try{return decodeURIComponent(escape(window.atob(e)))}catch(e){if(t)throw e;return""}}});function at(){return"undefined"!=typeof window&&/Mac|iPod|iPhone|iPad/.test(window.navigator.platform)}const lt="1.0.0";export{Xe as CompositionInput,K as InjectedComponent,Q as InjectedComponentSet,xe as LocalizeProvider,Ke as Markdown,ze as Plugin,lt as VERSION,ct as base64,Ee as createApplication,Y as createComponentDescriptor,ne as createStorageSlot,st as getPayload,Me as getPublicPath,at as isMac,oe as listStorageKeys,Se as useActions,we as useAsyncEffect,re as useBook,et as useDebounce,Ze as useDocumentTitle,rt as useEventTarget,ye as useIntlContext,it as useLocalStorageState,Pe as useModel,nt as useOptions,Ye as usePrevious,De as useSelector,Te as useStateWithCallback,ie as useThemeConfig,me as useThemeContext,tt as useThrottle};
//# sourceMappingURL=index.js.map
